export default {
  api: {
    baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001'
  },
  mapbox: {
    baseUrl: 'https://api.mapbox.com/geocoding/v5',
    accessToken: process.env.REACT_APP_MAPBOX_ACCESS_TOKEN || ''
  }
}
